export enum MessageTypes {
  uploadedFile = 'uploadedFile',
  urlsScreenshots = 'urlsScreenshots',
  screenshotStatistics = 'screenshotStatistics',
  sendDeclarationsToPLDA = 'sendDeclarationsToPLDA',
  sendDeclarationsToIDMS = 'sendDeclarationsToIDMS',
  sendDeclarationsToNlDeco = 'sendDeclarationsToNlDeco',
  customsSyncIDMS = 'customsSyncIDMS',
  idmsCallback = 'idmsCallback',
  nctsCallback = 'nctsCallback',
  sendOneDeclarationToIDMS = 'sendOneDeclarationToIDMS',
  sendDeclarationsBeGate = 'sendDeclarationsBeGate',
  uploadedFileResult = 'uploadedFileResult',
  sendingDeclarationsResult = 'sendingDeclarationsResult',
  syncDeclarationsResult = 'syncDeclarationsResult',
  fileProcessProgress = 'fileProcessProgress',
  syncBatchesStatusResults = 'syncBatchesStatusResults',
  declarationsToScrape = 'declarationsToScrape',
  scrapingProcessProgress = 'scrapingProcessProgress',
  screenshotProcessProgress = 'screenshotProcessProgress',
  keepAlive = 'keepAlive',
  persistFile = 'persistFile',
}

export interface PersistFileMessage {
  fileName: string;
  fileContents: string;
  mimeType: string;
}
